module.exports = __webpack_public_path__ + "media/images/logo-white-a14f7d84dc5082a919d6599cb7dce785.png";